<div class="error-box">
  <div class="error-body text-center">
    <h1 *ngIf="Success" class="error-title text-success">OK</h1>
    <h1 *ngIf="!Success" class="error-title text-danger">OOPS!!</h1>
    <h3 class="text-uppercase error-subtitle" style="font-size: xxx-large">{{Titolo}}</h3>
    <p class="text-muted m-t-30 m-b-30" style="font-size: large">{{Testo}}</p>
    <a href="#/login" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Vai al Login</a>
  </div>
</div>
